





















































import Loading from 'vue-loading-overlay';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import {
    AuthStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    StoreHelper,
    VehicleCompanyStoreHelper
} from '../../core/mixins';
import { PageTitle } from '../../core/components';
import Button from '../../core/components/Button.vue';
import LoginGoogle from '../../core/components/LoginGoogle.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import ModalAuthUser from '../components/ModalAuthUser.vue';
import {
    parameterSubscriptionIdQuantity,
    parameterTimeOffsetQuantity,
    reportDetailEmbedUrl,
    TemplateParams,
    TemplateParamsOptions
} from '../../../features/core/models';
import {
    copyTextToClipboard,
    existParams,
    getParameterFromUrl,
    getTimeOffset,
    goToUrl,
    NAME_ROUTES
} from '../../../features/core/utils';
import { Destroyed } from '../../../features/core/decorators';
import  $  from 'jquery';

@Component({
    components: {
        Loading,
        PageTitle,
        SectionTitle,
        Button,
        LoginGoogle,
        ModalAuthUser
    }
})
export default class ReportDetail extends Mixins(
    StoreHelper,
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    NotificationStoreHelper,
    AuthStoreHelper
) {
    reportUrl: string = '';
    reportTitle: string = 'Detalle de Reporte';
    reportId: string | null = null;
    thereAreUrlParams: boolean = existParams();
    canSeeTemplate: boolean = false;
    modalVisibility: boolean = false;
    isFullScreen: boolean = false;
    defaultIframeStyles: object = {
        width: '100%',
        border: 0,
        height: '100vh',
        position: 'static'
    };
    fullScreenIframeStyles: object = {
        ...this.defaultIframeStyles,
        position: 'fixed',
        top: '24px',
        left: 0,
        overflowY: 'auto',
        zIndex: 9
    };
    iframeStyles: object = this.defaultIframeStyles;

    mounted() {
       $('body').css('overflow', 'hidden')
        this.showTemplate();
    }

    @Destroyed
    destroy(){
        $('body').css('overflow', '')
    }

    setIframesStyles(styles) {
        this.iframeStyles = styles;
    }

    restoreIframeStyles() {
        this.isFullScreen = false;
        this.setIframesStyles(this.defaultIframeStyles);
    }

    seeIframeFullScreen() {
        this.isFullScreen = true;
        this.setIframesStyles(this.fullScreenIframeStyles);
    }

    handleSuccessLogin(userInfo) {
        this.showTemplate();
        this.canSeeTemplate = true;
    }

    showTemplate() {
        if (this.thereAreUrlParams) {
            this.reportId = getParameterFromUrl('id');
            let title = getParameterFromUrl('title');
            let subscriptionId = getParameterFromUrl(TemplateParamsOptions.subscription_id);
            if (this.reportId && subscriptionId !== null) {
                let suscriptionIdValue = subscriptionId;

                // this.reportUrl = getReportUrl(
                //     this.reportId,
                //     suscriptionIdValue,
                //     true, 
                // );
            }
            if (title !== null) {
                this.reportTitle = title;
            }
        }
    }

    onSuccess(googleUser) {
        // console.log(googleUser);
        // This only gets the user information: id, name, imageUrl and email
        // console.log(googleUser.getBasicProfile());
        this.showTemplate();
    }

    onFailure() {
        // console.log('onFailure');
    }

    copyReportLink() {
        if (this.reportId !== null) {
            copyTextToClipboard(this.reportUrl.replace('embed/', ''));
        }
    }

    backToReportsList() {
        // this.signOutGoogle();
        this.$router.push(NAME_ROUTES.REPORTS.path);
    }
}
